import { Paper, Radio, Stack, Text, TextInput } from '@mantine/core'

type Props = {
  indications: { value: string; label: string }[]
  value: string
  onChange: (value: string) => void
  otherValue?: string
  onOtherChange?: (value: string) => void
}

export const PrimaryIndicationSection = ({
  indications,
  value,
  onChange,
  otherValue,
  onOtherChange,
}: Props) => (
  <Paper p="md" withBorder>
    <Text fw={600} size="lg" mb="sm" className="text-[#0097CE]">
      PRIMARY INDICATION
    </Text>
    <Radio.Group value={value} onChange={onChange}>
      <Stack gap={4}>
        {indications.map((ind) => (
          <Radio key={ind.value} value={ind.value} label={ind.label} />
        ))}
      </Stack>
    </Radio.Group>
    {value === 'other' && onOtherChange && (
      <TextInput
        label="Specify"
        value={otherValue || ''}
        onChange={(e) => onOtherChange(e.target.value)}
        mt="xs"
        w={400}
      />
    )}
  </Paper>
)
